import { Button, Card, Empty, Flex, message, Spin } from "antd"
import { useActions } from "../../../hooks/useActions"
import { useEffect } from "react"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import CustomerCard from "./CustomerCard"
import AddUser from "./AddUser"

const CustomerContainer = ({}) => {
  const { fetchCustomers } = useActions()
  const { customers, loading, error } = useTypedSelector((select) => select.customers)

  useEffect(() => {
    fetchCustomers()
  }, [])

  useEffect(() => {
    if (error) {
      message.error("Error loading customers")
    }
  }, [error])

  return (
    <Spin spinning={loading}>
      <Card
        title={
          <Flex justify="space-between" align="center">
            Users
            <AddUser />
          </Flex>
        }
      >
        <Flex wrap justify="center" gap="small">
          {customers.length ? (
            customers.map((customer) => <CustomerCard key={customer._id} customer={customer} />)
          ) : (
            <Empty />
          )}
        </Flex>
      </Card>
    </Spin>
  )
}

export default CustomerContainer
